<template>
    <v-container fluid class="px-0">
        <v-row no-gutters>
            <v-col class="py-0" cols="12" sm="11">
                <p class="label text-16 gray--text" style="white-space: pre-wrap">
                    <b>{{ $t('ПУТЭ') }}:</b>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">&nbsp;{{ meterDetail.meter_type_name }}</span>
                        </template>
                        <span>{{ $t('Тип ПУТЭ') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span class="ml-5 label text-16 gray--text" v-bind="attrs" v-on="on">№&nbsp;{{ meterDetail.meter_number }}</span>
                        </template>
                        <span>{{ $t('Номер ПУТЭ') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span class="ml-5 label text-16 gray--text" v-bind="attrs" v-on="on">(ID&nbsp;{{ meterDetail.meter_rid }})</span>
                        </template>
                        <span>{{ $t('ID ПУТЭ') }}</span>
                    </v-tooltip>
                </p>
            </v-col>
            <v-col class="py-0" cols="12" sm="1" v-if="$vuetify.breakpoint.smAndUp">
                <router-link to="/uploads" class="float-right label font-weight-bold text-16 gray--text">{{ $t('Передать показания') }}</router-link>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" sm="3">
                <span class="label text-16 gray--text">
                    <b>{{ meterDetail.meter_action_name }}:</b>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">&nbsp;{{ meterDetail.date_meter_action | formatDate }}</span>
                        </template>
                        <span>{{ $t('Статус ПУТЭ (последнее действие)') }}</span>
                    </v-tooltip>
                </span>
            </v-col>

            <v-col cols="12" sm="6"></v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="pt-4" cols="12" :md="2" sm="3">
                <span class="label text-16 gray--text">
                    <b>{{ $t('Следующая проверка') }}:</b>
                    &nbsp;{{ meterDetail.next_meter_verify_date | formatDate }}
                </span>
            </v-col>
            <v-col cols="12" sm="6"></v-col>
        </v-row>
    </v-container>
</template>

<script>
import translate from '@/utils/translate.util';
import { mapActions } from 'vuex';
export default {
    computed: {
        meterDetail() {
            return translate(this.$store.state.meters.meterDetail, 'full');
        }
    },
    methods: {
        ...mapActions('meters', ['getMeterDetail'])
    },
    created() {
        this.$store.commit('meters/setMeterDetail', {});
        this.getMeterDetail(this.$parent.id);
    }
};
</script>

<style>
.next-line {
    white-space: nowrap !important;
}
</style>
